import { PreviewTableProps } from 'components/BulkUploads/components/PreviewTable';
import fnfInitiateUploadConfig from 'components/BulkUploads/configs/fnfInitiateUploadConfig';
import fnfSettlementUploadConfig from 'components/BulkUploads/configs/fnfSettlementUploadConfig';
import bulkOnboardingUploadConfig from 'components/BulkUploads/configs/bulkOnboardingConfig';
import bulkEmployeeUpdateConfig from 'components/BulkUploads/configs/bulkEmployeeUpdateConfig';
import bulkSalaryRegisterUpdateConfig from 'components/BulkUploads/configs/salaryRegisterUpdateConfig';
import { bulkCompensationAdjustmentConfig } from 'components/BulkUploads/configs/bulkCompensationAdjustmentConfig';
import { bulkOvertimeAdditionConfig } from 'components/BulkUploads/configs/bulkOvertimeAdditionConfig';
import { bulkTdsOverrideConfig } from 'components/BulkUploads/configs/bulkTdsOverrideConfig';
import { bulkOneTimePaymentConfig } from 'components/BulkUploads/configs/bulkOneTimePaymentConfig';
import { bulkLoansAdvancesConfig } from 'components/BulkUploads/configs/bulkLoansAdvancesConfig';
import { bulkFbpApprovedValuesConfig } from 'components/BulkUploads/configs/bulkFbpApprovedValuesConfig';
import { bulkPfOverrideConfig } from 'components/BulkUploads/configs/bulkPfOverrideConfig';
import { routePaths } from 'components/Routes/data';
import { useHistory } from 'react-router-dom';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { FeatureFlags } from 'types';
import { History } from 'history';
import { FormContextValue } from 'forms';
import { BulkUploadStagingDetailsSchemaContract } from 'schemas/BulkUploadStagingDetailsSchema';
import { PayrollCustomFieldDefinition } from 'api/gql-utils/employeeDataSettings/types';

export enum BulkUploadTypes {
  TYPE_BULK_ADDITION_DEDUCTION_LOP = 1,
  TYPE_BULK_SALARY_REVISION = 2,
  TYPE_BULK_FNF_INITIATION = 3,
  TYPE_BULK_FNF_SETTLEMENT = 4,
  TYPE_BULK_ONBOARDING = 5,
  TYPE_BULK_EMPLOYEE_UPDATE = 6,
  TYPE_BULK_SALARY_REGISTER_UPDATE = 7,
  TYPE_BULK_COMPENSATION_ADJUSTMENT = 8,
  TYPE_BULK_TDS_OVERRIDE = 9,
  TYPE_BULK_OVERTIME_ADDITION = 10,
  TYPE_BULK_ONE_TIME_PAYMENT = 11,
  TYPE_BULK_LOANS_ADVANCES = 12,
  TYPE_BULK_FBP_APPROVED_VALUES = 13,
  TYPE_BULK_PF_OVERRIDE = 14,
}
export const arrayGenericBulkUploadTypes = [
  BulkUploadTypes.TYPE_BULK_FNF_INITIATION,
  BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT,
  BulkUploadTypes.TYPE_BULK_ONBOARDING,
  BulkUploadTypes.TYPE_BULK_EMPLOYEE_UPDATE,
  BulkUploadTypes.TYPE_BULK_SALARY_REGISTER_UPDATE,
  BulkUploadTypes.TYPE_BULK_COMPENSATION_ADJUSTMENT,
  BulkUploadTypes.TYPE_BULK_TDS_OVERRIDE,
  BulkUploadTypes.TYPE_BULK_OVERTIME_ADDITION,
  BulkUploadTypes.TYPE_BULK_ONE_TIME_PAYMENT,
  BulkUploadTypes.TYPE_BULK_LOANS_ADVANCES,
  BulkUploadTypes.TYPE_BULK_FBP_APPROVED_VALUES,
  BulkUploadTypes.TYPE_BULK_PF_OVERRIDE,
];

export enum BulkUploadStatus {
  STATUS_VALIDATION_PENDING = 1,
  STATUS_VALIDATION_PROGRESS = 2,
  STATUS_VALIDATION_FAILED = 3,
  STATUS_VALIDATION_SUCCESS = 4,
  STATUS_EXECUTION_PENDING = 5,
  STATUS_EXECUTION_PROGRESS = 6,
  STATUS_EXECUTION_FAILED = 7,
  STATUS_EXECUTION_SUCCESS = 8,
  STATUS_EXECUTION_PARTIAL_SUCCESS = 9,
  STATUS_CANCELED = 10,
}

export const BulkUploadsValidationPollStatuses = [
  BulkUploadStatus.STATUS_VALIDATION_PENDING,
  BulkUploadStatus.STATUS_VALIDATION_PROGRESS,
];

export const BulkUploadsExecutionPollStatuses = [
  BulkUploadStatus.STATUS_EXECUTION_PENDING,
  BulkUploadStatus.STATUS_EXECUTION_PROGRESS,
];

export enum BulkUploadStep {
  DOWNLOAD_AND_UPLOAD_STEP = 1,
  PREVIEW_AND_EXECUTION = 2,
}

export const routeToTypeMap: { [key: string]: number } = {
  [routePaths.bulkUploads.bulkAdditionDeductionLOP.root]:
    BulkUploadTypes.TYPE_BULK_ADDITION_DEDUCTION_LOP,
  [routePaths.bulkUploads.bulkAdditionDeductionLOP.fileUpload]:
    BulkUploadTypes.TYPE_BULK_ADDITION_DEDUCTION_LOP,
  [routePaths.bulkUploads.bulkSalaryRevision.root]: BulkUploadTypes.TYPE_BULK_SALARY_REVISION,
  [routePaths.bulkUploads.bulkSalaryRevision.fileUpload]: BulkUploadTypes.TYPE_BULK_SALARY_REVISION,
};

export const stepToRouteMap: { [key: number]: { [key: number]: string } } = {
  [BulkUploadTypes.TYPE_BULK_ADDITION_DEDUCTION_LOP]: {
    [BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP]:
      routePaths.bulkUploads.bulkAdditionDeductionLOP.fileUpload,
    [BulkUploadStep.PREVIEW_AND_EXECUTION]:
      routePaths.bulkUploads.bulkAdditionDeductionLOP.previewScreen,
  },
  [BulkUploadTypes.TYPE_BULK_SALARY_REVISION]: {
    [BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP]: routePaths.bulkUploads.bulkSalaryRevision.fileUpload,
    [BulkUploadStep.PREVIEW_AND_EXECUTION]: routePaths.bulkUploads.bulkSalaryRevision.previewScreen,
  },
};

export const routeToStepMap: { [key: number]: { [key: string]: number } } = {
  [BulkUploadTypes.TYPE_BULK_ADDITION_DEDUCTION_LOP]: {
    [routePaths.bulkUploads.bulkAdditionDeductionLOP.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.bulkAdditionDeductionLOP.fileUpload]:
      BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.bulkAdditionDeductionLOP.previewScreen]:
      BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_SALARY_REVISION]: {
    [routePaths.bulkUploads.bulkSalaryRevision.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.bulkSalaryRevision.fileUpload]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.bulkSalaryRevision.previewScreen]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_FNF_INITIATION]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_SALARY_REGISTER_UPDATE]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_ONBOARDING]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_EMPLOYEE_UPDATE]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_COMPENSATION_ADJUSTMENT]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_ONE_TIME_PAYMENT]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_TDS_OVERRIDE]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_OVERTIME_ADDITION]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_LOANS_ADVANCES]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_FBP_APPROVED_VALUES]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
  [BulkUploadTypes.TYPE_BULK_PF_OVERRIDE]: {
    [routePaths.bulkUploads.root]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.initiate]: BulkUploadStep.DOWNLOAD_AND_UPLOAD_STEP,
    [routePaths.bulkUploads.preview]: BulkUploadStep.PREVIEW_AND_EXECUTION,
  },
};

export type UploadTypeConfig = {
  permissions?: string[];
  initiation: {
    feature?: FeatureFlags;
    permissions?: string[];
    actionHeaderText?: string;
    pageTitle: string;
    step1Title: string;
    step1Subtitle?: string;
    instructions: string[];
    // Return `{ isTemplateDownloaded: false }` (or throw) to indicate the file was
    // NOT downloaded to the browser (e.g. validation error, async email delivery),
    // which suppresses the "File downloaded successfully!" confirmation. Returning
    // void (the default for synchronous handlers) shows the confirmation.
    onSampleTemplateDownload: (
      orgId: number,
      reportType: number,
      options?: { prefillEmployeeDetails?: boolean },
    ) => void | Promise<void | { isTemplateDownloaded: boolean }>;
    ExtraFields?: React.ComponentType;
    hasMonthSelector?: boolean;
    skipMonthChangeConfirmation?: boolean;
    dropdownSelectorLabel?: string;
    dropdownOptions?: Array<{ value: string; label: string }>;
    getDropdownOptions?: (selectedMonth: string) => Array<{ value: string; label: string }>;
    defaultDropdownValue?: string;
    onDropdownOptionChange?: (selectedMonth: string | null) => void;
    onSubmitInitiation?: ({
      extraFieldsData,
      onSuccessCb,
      bulkUploadRecord,
    }: {
      extraFieldsData: FormContextValue<Record<string, any>>;
      onSuccessCb?: () => void;
      bulkUploadRecord?: BulkUploadDetailsSchemaContract[0] | null;
    }) => void;
  };
  preview: {
    showColumnsSelector?: boolean;
    sheets?: {
      [sheetTitle: string]: { columns: PreviewTableProps['columns'] };
    };
    feature?: FeatureFlags;
    permissions?: string[];
    renderConfirmationText?: (details: BulkUploadDetailsSchemaContract[0]) => string;
    onSuccessModalCtaClick?: (successCtaData?: Record<string, any>) => void;
    successModalCtaText?: string;
    successModalMainText?: string;
    successModalSubText?: (successSubTextData?: Record<string, any>) => string;
    onDownloadErrorReport?: (history?: ReturnType<typeof useHistory>) => void;
  } & Partial<Pick<PreviewTableProps, 'tableTopView' | 'columns'>>;
};

export type UploadTypeConfigCallbackParams = {
  isRxCurrentAccountMerchant: boolean;
  featureFlags: Record<FeatureFlags, boolean> | null;
  history: History<unknown>;
  stagingRecordData?: BulkUploadStagingDetailsSchemaContract[1];
  /** HRIS custom field definitions (display order), for per-field preview columns. */
  customFieldDefinitions?: PayrollCustomFieldDefinition[];
  actionsWithActiveWorkflows?: number[];
};

export type UploadTypeConfigCallback = (data: UploadTypeConfigCallbackParams) => UploadTypeConfig;

type UploadTypeConfigMap = {
  [key: number]: UploadTypeConfigCallback;
};

export const uploadTypeConfigMap: UploadTypeConfigMap = {
  [BulkUploadTypes.TYPE_BULK_FNF_INITIATION]: fnfInitiateUploadConfig,
  [BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT]: fnfSettlementUploadConfig,
  [BulkUploadTypes.TYPE_BULK_ONBOARDING]: bulkOnboardingUploadConfig,
  [BulkUploadTypes.TYPE_BULK_EMPLOYEE_UPDATE]: bulkEmployeeUpdateConfig,
  [BulkUploadTypes.TYPE_BULK_SALARY_REGISTER_UPDATE]: bulkSalaryRegisterUpdateConfig,
  [BulkUploadTypes.TYPE_BULK_COMPENSATION_ADJUSTMENT]: bulkCompensationAdjustmentConfig,
  [BulkUploadTypes.TYPE_BULK_TDS_OVERRIDE]: bulkTdsOverrideConfig,
  [BulkUploadTypes.TYPE_BULK_OVERTIME_ADDITION]: bulkOvertimeAdditionConfig,
  [BulkUploadTypes.TYPE_BULK_ONE_TIME_PAYMENT]: bulkOneTimePaymentConfig,
  [BulkUploadTypes.TYPE_BULK_LOANS_ADVANCES]: bulkLoansAdvancesConfig,
  [BulkUploadTypes.TYPE_BULK_FBP_APPROVED_VALUES]: bulkFbpApprovedValuesConfig,
  [BulkUploadTypes.TYPE_BULK_PF_OVERRIDE]: bulkPfOverrideConfig,
};
